import { render, staticRenderFns } from "./iconCompany.vue?vue&type=template&id=5223de09&scoped=true"
import script from "./iconCompany.vue?vue&type=script&lang=js"
export * from "./iconCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5223de09",
  null
  
)

export default component.exports